import React from "react";

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Karamiko error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-kraft p-8 text-center text-forest" data-testid="error-boundary">
          <img src="/logo-mini.png" alt="Karamiko" className="h-24 w-24" />
          <h1 className="font-display text-3xl font-bold">Ai! Un mico ens ha fet una mala jugada.</h1>
          <p className="max-w-md font-body text-forest/80">
            Alguna cosa no ha anat bé. Torna a carregar la pàgina i seguim el camí.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-full bg-forest px-7 py-3 font-display font-semibold text-paper transition-colors hover:bg-terracotta"
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
